<template>
	<li class="project-box">
		<div class="title">
			<h1>类目分布地图</h1>
			<el-tag class="eltagbtn" size="medium"
				@click="btnmap('a',$store.state.dataList[0].a100)">{{$store.state.dataList[0].a100}}</el-tag>
			<el-tag class="eltagbtn" size="medium"
				@click="btnmap('b',$store.state.dataList[0].a102)">{{$store.state.dataList[0].a102}}</el-tag>
			<div class="switchcss">
				<el-switch v-model="valuee" @change="clickswitch()" :key="1">
				</el-switch>
			</div>
		</div>
		<div>
			<el-input v-model="inputzdy" placeholder="请输入标题自定义内容">
				<el-button slot="append" type="primary" icon="el-icon-thumb" @click="onclickzdy"></el-button>
			</el-input>
		</div>
		<div id="map" :class="{headactive: liActiveClass == true}">
			<div class="echarttop">
				<div v-if="butt" class="fhbutt" :key="2">
					<el-button type="primary" @click="ifmap" plain>返回</el-button>
				</div>

			</div>
			<div v-if="valuee" class="prtxt" :key="3">
				<p>{{datatxt}}</p>
				<!-- <div class="cancel" >
          <i class="el-icon-close" @click="clickswitch()"></i>
        </div> -->

			</div>
			<div id="echart_china" ref="echart_china"></div>
			<div v-if="ifspan" class="splist" :key="5">
				<div @click="judgmentspan" class="butsp">
					<i class="el-icon-close" type="primary"></i>
				</div>
				<div v-for="(i,item) in complist" :key=item class="spfor">
					<el-link :href="'/enterprise/#/Inside?name='+i.name" target="_blank">
						{{i.name}}
					</el-link>
				</div>
			</div>
			<div v-if="valuee" class="fltxt" :key="4">
				<p>图表编制：网经社</p>
				<p>数据来源：WWW.100EC.CN</p>
			</div>
		</div>
		
	</li>

</template>
<script>
	// import { Console } from "console";
	import chinamap from "echarts/map/json/china.json";
	import {
		setTimeout
	} from "timers";
	// import Pinyin from "js-pinyin";

	export default {
		data() {
			return {
				liActiveClass: false,
				myChart: null,
				valuee: true,
				dataval: [],
				datamap: [],
				datatxt: '',
				indata: [],
				provincelist: [],
				butt: false,
				iflist: 1,
				complist: [],
				ifspan: false,
				inputzdy: '',
			};
		},
		mounted() {
			this.myChart = this.$echarts.init(this.$refs.echart_china);
			this.datatxt = '全国主要'+ this.$store.state.dataList[0].a102 + '公司分布统计地图';
			// setTimeout(()=>{
			// this.dataval= this.$store.state.mapdata

			// },1600)
		},
		created() {
			this.$store.dispatch('getmapAxios', {
				a102: this.$store.state.dataList[0].a102,
				pagesize: 10000,
			})

		},
		computed: {
			mapdataf() {
				return this.$store.state.mapdata;
			},
		},
		watch: {
			'$store.state.mapdata'(newval, val) {
				if (newval != val) {
					this.datamap = this.$store.state.mapdata
					this.dataval = this.datafun()
					this.init();
				}
			}
		},
		methods: {
			clickswitch(eve) {
				this.liActiveClass = !this.liActiveClass
				!this.valuee
			},
			ifmap() {
				this.iflist = 1
				this.init()
			},
			onclickzdy() {
				this.datatxt = this.inputzdy
			},
			btnmap(a, b) {
				this.datamap = []
				if (a == "a") {
					this.$store.dispatch('getmapAxios', {
						a100: this.$store.state.dataList[0].a100,
						pagesize: 10000,
					})
					this.datatxt = '全国主要'+this.$store.state.dataList[0].a100 + '分布统计地图'
				} else {
					this.$store.dispatch('getmapAxios', {
						a102: this.$store.state.dataList[0].a102,
						pagesize: 10000,
					})
					this.datatxt = '全国主要'+ this.$store.state.dataList[0].a102 + '分布统计地图'
				}
				// setTimeout(()=>{
				// this.dataval= this.$store.state.mapdata

				// },1600)
			},
			datafun() {
				//处理成地图需要的数据
				this.provincelis = []
				this.indata = []
				if (this.datamap.name == undefined) {
					this.datamap.forEach((item) => {
						// let repa = new RegExp('市','g')
						// let repb = new RegExp('省','g')
						let isAutonomy = item.a107.search('自治区') != -1
						// let isAutonomy2 = item.a107.search('') != -1
						if (isAutonomy) {
							item.a107 = item.a107.search('内') != -1 ? item.a107.substr(0, 3) : item.a107.substr(0,
								2)

						} else if (item.a107.indexOf('市') != -1 || item.a107.indexOf('省') != -1) {
							// console.log(item.a107.match(/(\S*)(省|市|特别行政区)/),'11')
							item.a107 = item.a107.match(/(\S*)(省|市|特别行政区)/)[1];
						}
						// if (item.a107.indexOf('市') !=-1 || item.a107.indexOf('省') !=-1 ) {
						//     if (item.a107.indexOf('市') !=-1) {
						//         item.a107 = item.a107.replace(repa,'')
						//     } else {
						//         item.a107 = item.a107.replace(repb,'')
						//     } 
						// }
						let bojdata = {
							name: item.a107
						}
						this.provincelist.push(item)
						this.indata.push(bojdata)
					})
					let valuedata = this.indata.reduce((obj, item) => {
						let find = obj.find(i => i.name === item.name)
						let _d = {
							name: item.name,
							value: 1
						}
						find ? find.value++ : obj.push(_d)
						return obj
					}, [])
					//保存地图数据
					return valuedata
					// context.commit('getmapdata', valuedata)
				}
				// if () {

				// }
			},
			init(name, mapjson, tais, valuedat) {
				//获取行业数据
				// this.$store.dispatch('getAxios', {a102: this.$store.state.dataList[0].a102})
				// 2. 注册可用的地图，只在 geo 组件或者map图表类型中使用
				// this.dataval= this.$store.state.mapdata
				let datay = []
				let datax = []
				let datavala = []
				datavala = valuedat ? valuedat : this.dataval
				datavala.sort((a, b) => parseInt(a.value) - parseInt(b.value));
				// console.log(this.dataval,'state')
				name ? this.butt = true : this.butt = false
				datavala.forEach((a) => {

					datay.push(a.name)
					datax.push(a.value)
				})
				datax = datax.reverse()
				datax = datax.slice(0, 10)
				datay = datay.reverse()
				datay = datay.slice(0, 10)
				this.$echarts.registerMap(name ? name : "china", mapjson ? mapjson :
					chinamap); //用导入的json文件注册一个name:china的地图组件
				// 3. 设置图表 option
				// var option = {
				//   geo: {
				//     type: "map",
				//     map: "china", //使用 registerMap 注册的地图名称
				//     label: {
				//     // label 设置文本标签的显示格式，去掉不影响显示地图
				//     normal: {
				//       color: "#000000",
				//       show: true, //显示省份名称
				//     },}}
				// };
				// 只显示一个地图的时候，用option,option2都可以。如果要在地图上加散点图，用 option 
				// 4. 显示地图
				let option = {
					//地图顶部标题
					// title: {
					//   text: this.datatxt,
					//   top:"10px",
					//   left: "center",
					//   textStyle: {
					//     color: "#000",
					//   },
					// },
					graphic: [{
						id: 'logo',
						type: 'image',
						left: '350',
						top: '60',
						style: {
							image: 'http://www.100ec.cn/Public/home/images/wjsLOGO.png?v=1.0',
							width: 190,
							height: 80,
							opacity: 0.3
						}
					}],
					tooltip: {
						formatter: function(params) {
							return (
								params.seriesName + "<br />" + params.name + "：" + params.value
							);
						}, //数据格式化
					},
					grid: {
						left: "76%",
						containLabel: true,
					},
					xAxis: [
						//x轴数据设置
						{
							type: "value",
							name: "Top10",
							min: 0,
							// max: 150,
							//interval: 30, //间隔数
							// splitNumber: 5,
							axisLabel: {
								formatter: "{value} ",
							},
							splitLine: {
								show: false,
							},
							axisLine: {
								//这是x轴文字颜色
								lineStyle: {
									color: "##855BD7",
								},
							},
						},
					],
					yAxis: [{
						type: "category",
						offset: 0,
						axisLine: {
							//这是y轴文字颜色
							lineStyle: {
								color: "##855BD7",
							},
						},
						data: datay,
						axisPointer: {
							type: "shadow",
						},
						axisTick: {
							show: false,
						},
					}, ],
					visualMap: {
						min: 0,
						max: 20,
						left: "12px",
						// left: "left",
						top: "bottom",
						text: ["高", "低"], //取值范围的文字
						textStyle: {
							color: "#000",
						},
						inRange: {
							color: ["#a5eeee", "rgb(0, 84, 211)"], //取值范围的颜色
						},
						show: true, //图注
					},
					// geo: 
					series: [{
							name: "行业数量",
							type: 'map',
							map: name ? name : "china",
							roam: true, //不开启缩放和平移
							zoom: 1.11, //视角缩放比例
							layoutCenter: ['38%', '50%'],
							layoutSize: '100%',
							label: {
								normal: {
									show: true,
									fontSize: "12",
									color: "rgba(0,0,0,0.7)",
								},
							},
							itemStyle: {
								normal: {
									// borderColor: "rgba(0, 0, 0, 0.2)",
									//  areaColor: 'rgba(0,60,153,0.8)',

									borderColor: "#02c0ff",
								},
								emphasis: {
									areaColor: "#F3B329", //鼠标选择区域颜色
									shadowOffsetX: 0,
									shadowOffsetY: 0,
									shadowBlur: 15,
									borderWidth: 0,
									shadowColor: "rgb(0, 84, 111)",
								},
							},
							data: datavala
						},
						// {
						//   name: "行业数量",
						//   type: "map",
						//   geoIndex: 0,
						//   data: this.dataval,
						// },

						{
							data: datax,
							type: "bar",
							barWidth: 20,
							label: {
								normal: {
									show: true,
									position: "right",
								},
							},
							itemStyle: {
								//通常情况下：
								normal: {
									//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
									color: "#855BD7"
								},
							},
						}
					],
				};
				var methodsobj = this.$options.methods;
				this.myChart.setOption(option, true); // 用 option 和 option2 效果一样
				let thas = this
				this.myChart.on("click", function(params) { //点击事件
					methodsobj.provincemap(params, thas)
				})
			},
			provincemap(a, b) {
				let pinyin = require('js-pinyin');
				pinyin.setOptions({
					checkPolyphone: false,
					charCase: 1
				})
				let dataname = pinyin.getFullChars(a.name)

				if (b.iflist == 1) {
					b.iflist = 2
					console.log(b.iflist, '2')
					let json = require(`echarts/map/json/province/${dataname}.json`)
					let provincedata = []
					b.provincelist.forEach((item) => {
						if (item.a107 == a.name) {
							return provincedata.push(item)
						}
					})
					let valuedata = []
					let provincename = []
					provincedata.forEach((item, index) => {
						if (a.name == '重庆' || a.name == '北京' || a.name == '上海' || a.name == '天津') {
							//  valuedata.push({ name: item.a109 }) 
							valuedata.push({
								name: item.a109
							})
							provincename.push({
								name: item.name
							})
						} else {
							//  valuedata.push({ name: item.a108 }) 
							valuedata.push({
								name: item.a108
							})
							provincename.push({
								name: item.name
							})
						}
					})
					valuedata = valuedata.reduce((obj, item) => {
						let _d = {}
						let find = ''
						find = obj.find(i => i.name === item.name)
						_d = {
							name: item.name,
							value: 1
						}
						find ? find.value++ : obj.push(_d)
						return obj
					}, [])
					b.init(dataname, json, b, valuedata)
				} else {
					b.companieslist(a.name, b)
				}
				// this.showButton = true
			},
			companieslist(area, b) {
				b.complist = []
				b.datamap.forEach((item) => {
					if (item.a108 == area) {
						b.complist.push(item)
					} else if (item.a109 == area) {
						b.complist.push(item)

					}
				})
				b.ifspan = true
			},
			judgmentspan() {
				this.ifspan = false
			}
		},

	}
</script>
<style scoped>
	#echart_china {
		/* width: 1100px; */
		height: 660px;
	}

	.switchcss {
		/* float: right; */
		position: relative;
		line-height: 43px;
	}

	/* .headactive {
  position: fixed;
  background-color: #fff;
  z-index: 2000;
  top: 100px;
} */
	.splist {
		display: flex;
		align-content: center;
		background: #fff;
		flex-flow: row wrap;
		/* padding-top: 45px; */
		position: relative;
		padding-left: 8px;
		padding-right: 35px;
		padding-bottom: 6px;
	}

	.eltagbtn {
		margin: auto;
	}

	.butsp {
		position: absolute;
		right: 8px;
		top: 8px;
		/* width: 30px; */
		/* height: 30px; */
		text-align: center;
		/* background: #8fcdff; */
		border-radius: 4px;

	}

	.posfixed {
		position: fixed;
		z-index: 1000;
		top: 80px;
		background-color: #fff;
	}

	.prtxt {
		/* width: 100%; */
		height: 70px;
		line-height: 70px;
		color: #ffffff;
		background-color: #0068B7;
		font-size: 26px;
		text-align: center;
		font-weight: 600;
		padding: 0 20px;
	}

	.echarttop {
		margin: 10px;
	}
	#map {
		margin-top: 16px;
	}
	.cancel {
		float: right;
		font-size: 20px;
		top: -70px;
		right: 10px;
		line-height: 70px;
		position: relative;
	}

	.cancel:hover {
		color: #54c9ff;
	}

	.butsp .el-icon-close {
		font-size: 24px;
		color: #45494c;
		line-height: 30px;
	}

	.spfor {
		padding: 2px 6px;
		margin: 2px 2px;
		background: #0068b7;
		border-radius: 4px;
	}

	.fltxt {
		height: 70px;
		line-height: 70px;
		color: #fff;
		background-color: #0068B7;
		font-size: 26px;
		text-align: center;
		font-weight: 600;
		padding: 0 30px;
	}

	.fltxt p:first-child {
		float: left;
	}

	.fltxt p:last-child {
		float: right;
	}

	.splist .el-link {
		color: #ffffff;
	}

	@media(max-width: 868px) {
		p {
			font-size: 16px;
		}

		#echart_china {
			/* width: 1100px; */
			height: 300px;
		}
	}
</style>